/*
 * POPUP FOOTER SURFACE
 *
 * Provides the shared responsive footer background, divider, and action alignment.
 *
 * Recent changes:
 * - Added a feature-neutral footer surface for task and note popups.
 * - Omits the empty leading column when a footer contains actions only.
 */

import { ReactNode } from 'react';
import { THEME_CLASSES } from '../../constants/themeConstants';

interface PopupFooterSurfaceProps {
  leading?: ReactNode;
  actions: ReactNode;
  className?: string;
  testId?: string;
}

export default function PopupFooterSurface({
  leading,
  actions,
  className = '',
  testId,
}: PopupFooterSurfaceProps) {
  return (
    <div
      data-testid={testId}
      className={`flex flex-col gap-4 border-t ${THEME_CLASSES.border} bg-slate-50/80 px-5 py-4 dark:bg-slate-950/40 sm:flex-row sm:items-center sm:px-6 ${leading ? 'sm:justify-between' : 'sm:justify-end'} ${className}`}
    >
      {leading && <div className="min-w-0">{leading}</div>}
      <div className="flex flex-wrap items-center justify-end gap-3">{actions}</div>
    </div>
  );
}

export type { PopupFooterSurfaceProps };
